import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinmanyatatech() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Manyata Tech Park Nagavara Bangalore',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Manyata Tech Park Nagavara Bangalore',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Manyata Tech Park Nagavara Bangalore, catering to the transportation needs of IT companies, corporate offices, and business centers in the area. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Manyata Tech Park Nagavara Bangalore.',

    top: 'Top Places to Visit in Bangalore with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace is an architectural marvel inspired by England’s Windsor Castle, built in the 19th century. The palace features Tudor-style architecture, fortified towers, elegant woodwork, and sprawling gardens. Visitors can explore the royal interiors, vintage furniture, and photo galleries. The palace also hosts cultural events, music concerts, and exhibitions, offering a blend of history, art, and heritage in the heart of Bangalore."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre green oasis in Bangalore, famous for its diverse collection of flora, centuries-old trees, glasshouse, and flower shows. The garden offers walking paths, serene lakes, and picturesque landscapes, making it ideal for nature lovers, photographers, and families. Seasonal flower exhibitions attract visitors from across the city and beyond."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a lush, sprawling park in central Bangalore, covering over 300 acres. With walking trails, jogging paths, playgrounds, and abundant greenery, it serves as a popular recreational spot for locals and tourists alike. The park also houses several government buildings and statues, creating a perfect blend of nature, culture, and history in the city."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an iconic government building and a symbol of Bangalore’s political and architectural heritage. Built in a Neo-Dravidian style, it features grand pillars, domes, and intricately carved stonework. Visitors admire the building’s majestic facade, especially during evening lightings. Though entry is restricted, the surrounding area and viewpoints provide excellent photo opportunities."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "The ISKCON Temple is a major spiritual and cultural center in Bangalore, dedicated to Lord Krishna. The temple complex features traditional architecture, colorful murals, a large prayer hall, and beautiful gardens. Visitors can attend devotional ceremonies, participate in cultural programs, and enjoy vegetarian meals at the temple’s food court. It is a serene escape for meditation and spiritual learning in the bustling city."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s bustling shopping hub, offering a variety of clothing, footwear, jewelry, accessories, and street food. It is popular among locals and tourists looking for shopping, bargain hunting, and exploring vibrant street markets. The lively atmosphere, diverse shops, and colorful storefronts make it a must-visit for retail enthusiasts."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a major wildlife destination near Bangalore, featuring a zoo, butterfly park, safari rides, and trekking trails. Visitors can observe lions, tigers, elephants, and a variety of other animals in naturalistic settings. The park is perfect for families, wildlife enthusiasts, and students seeking educational and recreational experiences close to the city."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is a picturesque water body located in central Bangalore, ideal for boating, photography, and evening strolls. The lake is surrounded by lush greenery, walking paths, and small islands. It is a peaceful spot for relaxation, picnics, and spending time with family or friends, offering a serene escape within the urban landscape."
  },
  {
    "title": "Nandi Hills",
    "description": "Located on the outskirts of Bangalore, Nandi Hills is a scenic hill station known for its sunrise views, trekking trails, and historical sites like Tipu Sultan’s Summer Palace. The hill offers a refreshing escape from the city heat, with cool breezes, lush landscapes, and panoramic vistas. It is a favorite destination for nature lovers, photographers, and adventure seekers."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla is one of India’s top amusement parks, located near Bangalore, offering thrilling rides, water slides, and family entertainment zones. The park is ideal for a fun-filled day with family and friends, featuring safe rides, adventure zones, and well-maintained facilities. Seasonal events and themed attractions make it a popular destination for locals and tourists seeking excitement and leisure."
  }
],


"services": [
{
"name": "Manyata Employee Shuttle",
"description": "Manyata Employee Shuttle provides large-scale workforce commuting solutions designed for companies operating inside Manyata Tech Park. With high-capacity shuttle vans, structured route planning, multi-shift operations, and GPS-enabled real-time monitoring, it ensures seamless, punctual, and safe employee travel. The service is supported by professional drivers, automated attendance integration, and centralized fleet management for smooth daily operations across all blocks of Manyata Embassy Tech Park."
},
{
"name": "Nagavara Corporate Transport",
"description": "Nagavara Corporate Transport offers reliable and fully managed transportation solutions for corporations, IT offices, and business centers around Nagavara and Outer Ring Road. The service includes premium vehicles, skilled chauffeurs, trip optimization, shift scheduling, and a powerful safety framework with live tracking. It ensures consistent mobility for employees, executives, and corporate teams working in and around the Nagavara–Manyata belt."
},
{
"name": "IT Park Cab Manyata",
"description": "IT Park Cab Manyata provides dedicated cab services customized for the daily mobility needs of software firms, IT companies, and startups located in Manyata Tech Park. With optimized routes, priority dispatching, trained drivers, and strict punctuality standards, the service ensures reliable, safe, and smooth travel for employees and business personnel."
},
{
"name": "Staff Pickup Drop Manyata",
"description": "Staff Pickup Drop Manyata offers structured and punctual pick-up/drop solutions for thousands of employees commuting to Manyata Tech Park. With intelligent route mapping, shift-based scheduling, real-time tracking, and compliance-driven operations, it guarantees timely workforce movement for large and medium-sized companies."
},
{
"name": "Business Cab Manyata Tech Park",
"description": "Business Cab Manyata Tech Park provides executive-grade corporate travel for meetings, client visits, inter-office movement, and airport transfers. Featuring professional chauffeurs, comfortable sedans/SUVs, and instant dispatch support, it ensures a smooth and premium business travel experience within and beyond Manyata Tech Park."
},
{
"name": "Monthly Cab Manyata",
"description": "Monthly Cab Manyata provides long-term cab rental solutions for IT companies, corporate offices, and startups requiring regular employee commute or dedicated corporate vehicles. The service includes driver allocation, vehicle maintenance, GPS tracking, and 24/7 operational support, ensuring uninterrupted and cost-efficient travel throughout the month."
},
{
"name": "Employee Commute Manyata",
"description": "Employee Commute Manyata focuses on daily staff mobility with well-planned routes, professional chauffeurs, shift-aligned transport, and safety-driven operations. Ideal for companies operating in Manyata Tech Park, it ensures employees reach the campus on time with comfort and reliability."
},
{
"name": "Office Cab Manyata",
"description": "Office Cab Manyata delivers office commute solutions for small teams, executives, and corporate employees traveling to and from Manyata Tech Park. The service includes on-time pickups, clean vehicles, trained drivers, and flexible routing suitable for hybrid and full-time workforce patterns."
},
{
"name": "Best Corporate Cab Manyata",
"description": "Best Corporate Cab Manyata provides premium-grade corporate cab services with top-rated drivers, executive vehicles, advanced safety systems, and unmatched punctuality. Designed for senior management travel, client movement, and seamless employee commute, it ensures high-quality mobility for companies in Manyata Tech Park."
},
{
"name": "Affordable Cab Manyata",
"description": "Affordable Cab Manyata offers budget-friendly cab solutions ideal for startups, SMEs, and companies seeking cost-effective commute services around Manyata Tech Park. With reliable vehicles, trained chauffeurs, and efficient routing, it provides a perfect balance of affordability and quality."
},
{
"name": "Outstation Cab Manyata",
"description": "Outstation Cab Manyata provides dependable long-distance transportation for corporate teams, executives, and IT professionals traveling for client meetings, plant visits, or business events. With comfortable vehicles, experienced drivers, and safety-first operations, it ensures smooth and stress-free intercity travel."
},
{
"name": "Sedan Cab Manyata",
"description": "Sedan Cab Manyata offers premium, comfortable, and executive-class sedans ideal for business travel, manager-level commutes, airport trips, and daily office transportation. The vehicles come with superior interiors, GPS tracking, and experienced chauffeurs to ensure a refined travel experience."
},
{
"name": "SUV Cab Manyata",
"description": "SUV Cab Manyata provides spacious and powerful SUVs suitable for executive groups, long-distance travel, team movement, and premium corporate mobility. Equipped with high-comfort seating, strong safety features, and trained chauffeurs, it supports both daily commute and business travel needs."
},
{
"name": "Company Cab Manyata Tech Park",
"description": "Company Cab Manyata Tech Park offers dedicated corporate cabs for employee mobility, executive movement, and meeting-based travel. It features a managed fleet, verified drivers, maintenance-included plans, and proactive service coordination for companies located within the tech park."
},
{
"name": "Corporate Shuttle Nagavara",
"description": "Corporate Shuttle Nagavara provides high-capacity shuttle services for large corporate teams working in the Nagavara–Manyata region. With minibuses, AC shuttles, centralized dispatching, and multi-route operations, it ensures efficient and well-managed transportation for employees across multiple shifts."
}
],

"tableData": [
["Manyata Employee Shuttle", "Nagavara Corporate Transport"],
["IT Park Cab Manyata", "Staff Pickup Drop Manyata"],
["Business Cab Manyata Tech Park", "Monthly Cab Manyata"],
["Employee Commute Manyata", "Office Cab Manyata"],
["Best Corporate Cab Manyata", "Affordable Cab Manyata"],
["Outstation Cab Manyata", "Sedan Cab Manyata"],
["SUV Cab Manyata", "Company Cab Manyata Tech Park"],
["Corporate Shuttle Nagavara", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Manyata Tech Park Nagavara Bangalore",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Manyata Tech Park, Nagavara Bangalore, ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee punctual pickups and drop-offs across Manyata Tech Park and nearby corporate hubs, helping professionals reach their offices and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a comfortable and secure commute for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible cab rental plans tailored to meet the commuting needs of businesses and employees in Manyata Tech Park and Nagavara Bangalore."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team offers round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Manyata Tech Park, Nagavara Bangalore?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies operating in Manyata Tech Park, Nagavara Bangalore.',
  },
  {
    question: 'What types of corporate cab services do you offer in Manyata Tech Park?',
    answer: 'We provide employee transportation, corporate pickups and drops, shuttle services, airport transfers, and dedicated fleet management for IT and corporate offices.',
  },
  {
    question: 'Do you support daily employee commute services for companies in Manyata Tech Park?',
    answer: 'Yes, we offer structured daily commute services with timely pickups, smart routing, and multi-shift transportation for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Manyata Tech Park?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What vehicle options are available for corporate cab services?',
    answer: 'We offer sedans, hatchbacks, SUVs, Innova Crysta, luxury cars, and tempo travellers depending on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate transportation contracts in Manyata Tech Park?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and reliable fleet operations.',
  },
  {
    question: 'Are safety and tracking features included in your corporate transportation services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure safety.',
  },
  {
    question: 'Do you support night and rotational shift cab services in Manyata Tech Park?',
    answer: 'Absolutely. We manage transportation for early morning, night, weekend, and rotational shifts for corporate staff.',
  },
  {
    question: 'What payment modes are supported for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Siddharth Rangan',
    feedback: 'Highly reliable corporate cab service for our Manyata Tech Park office. Punctual and well-managed fleet operations.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Harini Desai',
    feedback: 'Professional and efficient cab services. The drivers are courteous, and the vehicles are always clean and comfortable.',
    rating: 5,
  },
];



































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Manyata Tech Park Nagavara Bangalore",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-manyata-tech-park.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers professional corporate cab services in Manyata Tech Park Nagavara Bangalore, including employee shuttles, IT park cabs, staff pickup & drop, business cabs, office commute solutions, monthly cab plans, outstation trips, and corporate fleet solutions for companies operating in Manyata Tech Park and Nagavara.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-manyata-tech-park-nagavara"
  }
};







  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in Manyata Tech Park Nagavara Bangalore | Employee & Business Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Manyata Tech Park Nagavara Bangalore including employee shuttles, IT park cabs, staff pickup & drop, business cabs, monthly cab plans, outstation trips, and corporate fleet solutions for companies in Manyata and Nagavara."
  />

  <meta
    name="keywords"
    content="Manyata Employee Shuttle, Nagavara Corporate Transport, IT Park Cab Manyata, Staff Pickup Drop Manyata, Business Cab Manyata Tech Park, Monthly Cab Manyata, Employee Commute Manyata, Office Cab Manyata, Best Corporate Cab Manyata, Affordable Cab Manyata, Outstation Cab Manyata, Sedan Cab Manyata, SUV Cab Manyata, Company Cab Manyata Tech Park, Corporate Shuttle Nagavara"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinmanyatatech;